// extracted by mini-css-extract-plugin
export default {"status":"ONa2mb","body":"JknNrj","spinner":"BKTzQ5","title":"fhg0j_","colorGreen":"cw9tir","description":"wnPZum"};